import debounce from 'lodash-es/debounce';
import Flickity from 'flickity';
import React, { useEffect, useRef } from 'react';
import EventTile from '../../../components/React/EventTile.jsx';

const handleResize = debounce((carousel) => {
  if (!carousel) {
    return;
  }
  carousel.resize();
}, 250);

const UpcomingEventsContainer = (props) => {
  const events = props.events;

  const carouselEl = useRef(null);
  const carousel = useRef(null);

  useEffect(() => {
    carousel.current = new Flickity(carouselEl.current, {
      imagesLoaded: true,
      cellAlign: 'center',
      groupCells: true,
      draggable: true,
      dragThreshold: 10,
    });

    const resizeHandler = () => handleResize(carousel.current);
    window.addEventListener('resize', resizeHandler);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  return (
    <div>
      <div className="UpcomingEvents--desktop" data-upcoming-events-desktop>
        {events.map((event, i) => (
          <EventTile
            key={`UpcomingEvent-${i}`}
            event_date={event.event_date}
            title={event.title}
            excerpt={event.excerpt}
            image={event.image}
            url={event.url}
            desktop="true"
          />
        ))}
      </div>
      <div className="UpcomingEvents--mobile" ref={carouselEl} data-upcoming-events-mobile>
        {events.map((event, i) => (
          <EventTile
            key={`UpcomingEvent-${i}`}
            event_date={event.event_date}
            title={event.title}
            excerpt={event.excerpt}
            image={event.image}
            url={event.url}
          />
        ))}
      </div>
    </div>
  );
};

UpcomingEventsContainer.defaultProps = {};

export default UpcomingEventsContainer;
